<template>
  <div class="content-container">
    <!-- Search Component -->
    <search-comp
      :search-show="true"
      @onSearch="attachData"
      @onReset="onResetParams"
    >
      <template>
        <div class="das-form-container">
          <div class="das-form-group">
            <div class="das-form-row align-end">
              <div class="das-form-col col-4">
                <div class="das-form-input">
                  <div class="label">Ngày</div>
                  <div class="flex gap-10">
                    <CalendarSelect
                      v-model="searchParams.dateFrom"
                      style="width: 100%"
                      mode="date"
                    />
                    <CalendarSelect
                      v-model="searchParams.dateTo"
                      style="width: 100%"
                      mode="date"
                    />
                    <!-- <MultiCalendar
                      class="use-icon"
                      :from-date="searchParams.dateFrom"
                      :to-date="searchParams.dateTo"
                    /> -->
                  </div>
                </div>
              </div>
              <!-- <div class="das-form-col col-3">
                <div class="das-form-input">
                  <div class="checkbox-container">
                    <div class="checks-wrap">
                      <input
                        id="cpSpdTp1"
                        v-model="searchParams.radioValue"
                        type="radio"
                        value="1"
                      />
                      <label for="cpSpdTp1">City Ledger</label>
                    </div>
                    <div class="checks-wrap ml-10">
                      <input
                        id="cpSpdTp2"
                        v-model="searchParams.radioValue"
                        type="radio"
                        value="2"
                      />
                      <label for="cpSpdTp2">Thẻ tín dụng</label>
                    </div>
                  </div>
                </div>
              </div> -->
            </div>
          </div>
        </div>
      </template>
    </search-comp>
    <div v-loading="loading" class="grid-scroll">
      <GridVx
        ref="agGrid"
        :columns="columns"
        :auto-size-cell="false"
        :auto-select-first-row="false"
        dom-layout="scroll"
        :rows="rows"
        class="agGrid"
        @rowClicked="isRowSelected = true"
        @refresh="onRefresh"
      />
    </div>
    <div class="button-containers mb-0">
      <button
        :disabled="!isRowSelected"
        class="btn primary small"
        @click="setDateEqual(1)"
      >
        {{ $t('button.setDateEqualComeDate') }}
      </button>
      <button
        :disabled="!isRowSelected"
        class="btn primary small"
        @click="setDateEqual(2)"
      >
        {{ $t('button.setDateEqualDepartDate') }}
      </button>
      <!-- <button
        :disabled="!isRowSelected"
        class="btn primary small"
        @click="debtAccountNumber"
      >
        {{ $t('button.debtAccount') }}
      </button> -->
      <button
        :disabled="!isRowSelected"
        class="btn primary small"
        @click="transferDebt"
      >
        {{ $t('button.transferDebt') }}
      </button>
      <button class="btn primary small" @click="downloadExcel">
        {{ $t('button.downloadExcel') }}
      </button>
    </div>
    <el-dialog
      :title="$t('dialog.debtAccountTitle')"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      width="900px"
    >
      <div class="das-form-container">
        <div class="das-form-group">
          <div class="das-form-row align-end">
            <div class="das-form-col col-4">
              <div class="das-form-input">
                <div class="label">Thông tin</div>
                <input type="text" />
              </div>
            </div>
            <div class="das-form-col col-4">
              <div class="checkbox-wrap">
                <!-- <input
              id="cpSpdTp4"
              v-model="searchParams.showNotActive"
              type="checkbox"
              @change="attachData()"
            /> -->
                <input id="cpSpdTp4" type="checkbox" />
                <label for="cpSpdTp4">{{
                  $t('searchBox.showInactivedAccount')
                }}</label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-loading="loading" style="height: 300px">
        <GridVx
          ref="debtAccountGrid"
          :columns="debtAccountCols"
          :auto-size-cell="false"
          :auto-select-first-row="false"
          dom-layout="scroll"
          :rows="debtAccountRows"
          class="agGrid"
          @refresh="onRefresh"
        />
      </div>
      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button class="btn primary small" @click="dialogFormVisible = false">
            {{ $t('button.select') }}
          </button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import bus from '@/utils/bus'
import { downloadFile } from '@/utils/file-handler'
import {
  getListFromReception,
  setDateEqual,
  postDebtTransfer,
  downloadInvoiceListFromReception
} from '@/api/accounting/get-from-reception'
export default {
  data() {
    return {
      isRowSelected: false,
      loading: false,
      columns: [
        {
          headerName: this.$t('grid.column.transPage'),
          field: 'source',
          tooltipField: 'source',
          maxWidth: 100
        },
        {
          headerName: this.$t('grid.column.folioInvoice'),
          field: 'folio',
          tooltipField: 'folio',
          maxWidth: 150
        },
        {
          headerName: this.$t('grid.column.group'),
          field: 'booking_group_code',
          tooltipField: 'booking_group_code',
          maxWidth: 150
        },
        // {
        //   headerName: this.$t('grid.column.debtSurplus'),
        //   field: 'money'
        // },
        {
          headerName: this.$t('grid.column.companyName'),
          field: 'agent_name',
          tooltipField: 'agent_name',
          maxWidth: 150
        },
        {
          headerName: this.$t('grid.column.customerName'),
          field: 'traveller',
          tooltipField: 'traveller',
          maxWidth: 150
        },
        {
          headerName: this.$t('grid.column.comeDate'),
          field: 'arrive_date',
          valueGetter: param => {
            return this.$displayDate(param?.data?.arrive_date) || null
          },
          maxWidth: 150
        },
        {
          headerName: this.$t('grid.column.departDate'),
          field: 'depart_date',
          valueGetter: param => {
            return this.$displayDate(param?.data?.depart_date) || null
          },
          maxWidth: 150
        },
        {
          headerName: this.$t('grid.column.transactionDate'),
          field: 'trade_date',
          valueGetter: param => {
            return this.$displayDate(param?.data?.trade_date) || null
          },
          maxWidth: 150
        },
        // {
        //   headerName: this.$t('grid.column.amountOfDebtInvoice'),
        //   field: 'money'
        // },
        {
          headerName: this.$t('grid.column.amountOfMoney'),
          field: 'money',
          valueGetter: param => {
            return this.$displayCurrency(param?.data?.money) || null
          },
          maxWidth: 150
        },
        {
          headerName: this.$t('grid.column.debtAccountName'),
          field: 'debt_account_name'
        },
        {
          headerName: this.$t('grid.column.debtAccount'),
          field: 'debt_account_num'
        },
        {
          headerName: this.$t('grid.column.transferDebt'),
          field: 'debt_transfer'
        }
      ],
      debtAccountCols: [
        {
          headerName: this.$t('grid.column.accountNum'),
          field: 'code'
        },
        {
          headerName: this.$t('grid.column.accountName'),
          field: 'code'
        },
        {
          headerName: this.$t('grid.column.surplus'),
          field: 'code'
        },
        {
          headerName: this.$t('grid.column.taxNumber'),
          field: 'code'
        },
        {
          headerName: this.$t('grid.column.address'),
          field: 'code'
        },
        {
          headerName: this.$t('grid.column.email'),
          field: 'code'
        },
        {
          headerName: this.$t('grid.column.phoneNumber'),
          field: 'code'
        },
        {
          headerName: this.$t('grid.column.debtDate'),
          field: 'code'
        },
        {
          headerName: this.$t('grid.column.debtMaxAmount'),
          field: 'code'
        },
        {
          headerName: this.$t('grid.column.active'),
          field: 'code'
        }
      ],
      rowId: null,
      rows: [],
      debtAccountRows: [
        {
          code: 'Test data'
        }
      ],
      form: [],
      titlePopup: '',
      totalPage: 0,
      currentPage: 0,
      isEdit: false,
      dialogFormVisible: false,
      searchParams: {
        dateFrom: null,
        dateTo: null
        // radioValue: '1'
      },
      taxItem: {
        code: null,
        level: null,
        desc: '',
        order: 1
      }
    }
  },
  watch: {
    dialogFormVisible() {
      this.dialogFormVisible ? null : this.resetInfo()
    }
  },
  beforeMount() {
    this.context = { componentParent: this }
  },
  mounted() {
    this.attachData()
  },
  methods: {
    async downloadExcel() {
      bus.$emit('startLoader', { msg: '' })
      await downloadInvoiceListFromReception(this.searchParams)
        .then(res => {
          downloadFile(res, 'Danh sách nhận từ lễ tân.xlsx')
          this.$message({
            type: 'success',
            message: this.$t('successMsg.downloadSuccessful')
          })
        })
        .catch(err => {
          this.$message({
            type: 'error',
            message: this.$t('errorMsg.downloadError')
          })
        })
        .finally(() => {
          bus.$emit('endLoader')
        })
    },
    onResetParams() {
      this.$nullValueInObj(this.searchParams)
      this.attachData()
    },
    async setDateEqual(type) {
      const gridApi = this.$refs.agGrid.gridApi
      const row = gridApi.getSelectedRows()[0]
      const data = [
        {
          id: null,
          date: null
        }
      ]
      if (type === 1) {
        data[0].id = row.id
        data[0].date = this.$moment(row.arrive_date).format('YYYY-MM-DD')
      } else {
        data[0].id = row.id
        data[0].date = this.$moment(row.depart_date).format('YYYY-MM-DD')
      }
      await setDateEqual(data)
        .then(async res => {
          const message = res.message
          await this.attachData()
          this.dialogFormVisible = false
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
    },
    async transferDebt() {
      const gridApi = this.$refs.agGrid.gridApi
      const row = gridApi.getSelectedRows()[0]
      await postDebtTransfer(row.id)
        .then(async res => {
          const message = res.message
          await this.attachData()
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
    },
    debtAccountNumber() {
      this.dialogFormVisible = true
    },
    // checkRowSelected(data) {
    //   const gridApi = data
    //   const row = gridApi.getSelectedRows()[0]
    //   if (row) {
    //     return true
    //   } else {
    //     this.$message({
    //       type: 'error',
    //       message: this.$t('errorMsg.selectRow')
    //     })
    //     return false
    //   }
    // },
    onRefresh(data) {
      let params = {
        orderBy: data.orderBy,
        orderTp: data.sort
      }
      this.searchParams = { ...this.searchParams, ...params }
      this.attachData()
    },
    resetInfo() {
      this.isEdit = false
      this.$nullValueInObj(this.taxItem)
    },
    openDialog() {
      this.dialogFormVisible = true
    },
    // table controller
    onRowClick(index) {
      document.getElementById(`currency-${index}`).classList.add('row-focus')
      if (this.rowId != null) {
        document
          .getElementById(`currency-${this.rowId}`)
          .classList.remove('row-focus')
      }
      this.rowId = index
    },
    async attachData() {
      this.loading = true
      let data = await getListFromReception(this.searchParams)
      this.isRowSelected = false
      this.loading = false
      this.rows = data.data
      // this.rows = [
      //   {
      //     id: 1,
      //     source: 'abc',
      //     folio: 'def',
      //     booking_group_code: 'hehe',
      //     agent_name: 'vingroup',
      //     traveller: 'sontung',
      //     arrive_date: '2023-12-12',
      //     depart_date: '2024-1-1',
      //     trade_date: '2024-12-12',
      //     money: 20000,
      //     debt_account_name: 'vietcombank',
      //     debt_account_num: 1234,
      //     debt_transfer: 20000
      //   }
      // ]
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
